import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

const Group = styled.div`
  max-width: 1022px;
  margin: auto;
  height: 100dvh;
  ${HideScrollbar}
  padding-inline: var(--space-24);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const Content = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-8);
  background-color: var(--background-primary);
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    margin-bottom: var(--space-96);
  `)}
`;

const ProjectItem = styled.div`
  ${FlexBetween}
  gap: var(--space-40);
  padding: var(--space-16);
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;
const HeaderTitle = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
`;
const Title = styled.h1`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const ProjectName = styled.div`
  max-width: 540px;
  width: 100%;
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-8);
  ${mobile_xl(css`
    gap: var(--space-4);
  `)}
`;

const AssignGroup1 = styled.div`
  width: 100%;
  max-width: 140px;
  ul {
    display: flex;
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
    justify-content: flex-end;
  }

  li {
    margin-left: -10px;
  }

  small {
    padding: var(--space-5);
    border-radius: var(--border-radius-full);
    background: var(--text-secondary);
    border: 2px solid var(--background-primary);
  }

  span {
    ${Typography.body_xs_semibold}
    color: var(--text-white);
  }

  .plus-icon {
    width: 24px;
    height: 24px;
    border-radius: var(--border-radius-full);
    ${FlexCenter}
    color: var(--text-white);
    background-color: var(--text-secondary);
    ${Typography.body_xs_semibold}
    border: 1px solid var(--background-primary);
    position: relative;
    top: 0;
    z-index: var(--z-index-base);
  }
`;

const HeaderBlock = styled.div`
  ${FlexBetween}
  background-color: var(--background-secondary);
  margin-block: var(--space-14) var(--space-24);
  gap: var(--space-30);
`;

const Heading = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const Icon = styled.div`
  ${FlexCenter}
  position: relative;
`;

const RightContent = styled.div`
  ${AlignCenter}
  gap: var(--space-20);
  .active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
  }
`;

export {
  Group,
  AssignGroup1,
  ProjectName,
  Text,
  Title,
  ProjectItem,
  Content,
  Heading,
  HeaderBlock,
  Icon,
  HeaderTitle,
  RightContent
};
